import React from 'react';
import { LazySection } from './LazySection';
export function Cierre() {
  return <LazySection className="bg-ink text-cream text-center !py-[80px] md:!py-[100px]" data-id="element-72">
      <div className="container-wide" data-id="element-73">
        <h2 className="text-cream text-[clamp(32px,5vw,54px)] max-w-[820px] mx-auto mb-5 leading-[1.15]" data-id="element-74">
          Podés seguir intentando cambiar algo que no empezó con vos…{' '}
          <em className="text-gold-light" data-id="element-75">
            o empezar por el{' '}
            <span className="highlight-keyword-light" data-id="element-76">origen</span> hoy
          </em>
          .
        </h2>
        <p className="text-cream/80 text-[17px] max-w-[580px] mx-auto mb-[50px]" data-id="element-77">
          El primer paso no tiene que ser perfecto.{' '}
          <strong data-id="element-78">Solo tiene que ser hoy.</strong>
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-[720px] mx-auto mb-[30px]" data-id="element-79">
          <div className="bg-white/5 border border-cream/10 rounded-[16px] p-7 text-center" data-id="element-80">
            <div className="font-serif text-[17px] text-cream mb-1" data-id="element-81">
              Acceso Esencial
            </div>
            <div className="text-[12px] text-cream/60 mb-4" data-id="element-82">
              6 módulos · sin bonos
            </div>
            <div data-id="element-83">
              <span className="text-[13px] text-cream/40 line-through" data-id="element-84">
                $29.990
              </span>
            </div>
            <div className="font-serif text-[30px] text-gold-light font-medium mb-4 leading-none" data-id="element-85">
              $19.990
            </div>
            <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWNB8kX9bOq8QdQOiOFYpqy1/es-ar?_r=AQABGsHkzY998w9u6VIq0cHFmFe2DF0gJLpJ6aHDy0v2y_M&preview_theme_id=186487341342" className="block py-3 px-4 rounded-full text-[13px] font-semibold no-underline bg-transparent border-[1.5px] border-cream/30 text-cream transition-colors duration-200 hover:bg-cream hover:text-ink" data-id="element-86">
              Quiero el Esencial →
            </a>
          </div>

          <div className="bg-gold/10 border border-gold rounded-[16px] p-7 text-center" data-id="element-87">
            <div className="font-serif text-[17px] text-cream mb-1" data-id="element-88">
              ★ Sistema Completo
            </div>
            <div className="text-[12px] text-cream/60 mb-4" data-id="element-89">
              6 módulos + 4 bonos
            </div>
            <div data-id="element-90">
              <span className="text-[13px] text-cream/40 line-through" data-id="element-91">
                $44.990
              </span>
            </div>
            <div className="font-serif text-[30px] text-gold-light font-medium mb-4 leading-none" data-id="element-92">
              $29.990
            </div>
            <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWNB8kcghSL4J4gLE9bfSljF/es-ar?_r=AQABY9vu39JZ03XZNVfeI0RZdrnBvs1la7xma74CW_r41Jo&preview_theme_id=186487341342" className="block py-3 px-4 rounded-full text-[13px] font-semibold no-underline bg-gold border-[1.5px] border-gold text-ink transition-colors duration-200 hover:bg-gold-light hover:border-gold-light" data-id="element-93">
              Quiero el Completo →
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-5 text-[13px] text-cream/60 mt-5" data-id="element-94">
          <span className="inline-flex items-center gap-1.5" data-id="element-95">
            🔒 Pago 100% seguro
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-96">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-97">
            🛡️ Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-98">
            💳 Mercado Pago
          </span>
        </div>
      </div>
    </LazySection>;
}